export default __webpack_public_path__ + "static/media/clinic3.7e9edee1.jpg";